import styled from 'styled-components';
import { Props } from './types';

type T = Pick<Props, 'size' | 'weight' | 'align' | 'truncate' | 'underline' | 'uppercase' | 'palette'>;

export const Root = styled.span<T>`
  color: ${({ palette }) => {
    switch (palette) {
      case 'primary': {
        return '#ea475c';
      }
      case 'secondary': {
        return '#888';
      }
      default: {
        return '#fff';
      }
    }
  }};

  font-weight: ${({ weight }) => {
    switch (weight) {
      case 'regular': {
        return 'bolder';
      }
      case 'strong': {
        return 'bold';
      }
      // case "weak"
      default: {
        return 'normal';
      }
    }
  }};

  text-transform: ${({ uppercase }) => (uppercase ? 'uppercase' : 'none')};
  text-decoration: ${({ underline }) => (underline ? 'underline' : 'none')};
  overflow-wrap: anywhere;
`;
